import '../../App.css'
import { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid'
import { SelectGenericFromTable } from '../universal/Axios';
import { PlayArrow, Pause, PlayCircle } from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button'


const SignalNoiseSeparationInputTable = ({ comparativeSetID, selectSignalNoiseSeparationInput, selectedSignalNoiseSeparationInput, selectionEnabled }) => {
    const [signalNoiseSeparationInputs, setSignalNoiseSeparationInputs] = useState([]);
    const [currentlyPlayingAudio, setCurrentlyPlayingAudio] = useState(false);
    const [audio, setAudio] = useState(new Audio())

    useEffect(() => {
        let selectQuery = 'SELECT snsi.id as id, af.name, af.bucket, af.bucket_folder, af.type, af.created_date FROM signal_noise_separation_input snsi JOIN audio_file af ON snsi.combined_audio_file_id = af.id';
        if (comparativeSetID !== null) {
            selectQuery += ' JOIN comparative_set_snsi_mapping cssm ON cssm.snsi_id = snsi.id AND cssm.comparative_set_id = "' + comparativeSetID + '"';
        }
        selectQuery += ' ORDER BY created_date DESC LIMIT 20000;'
        SelectGenericFromTable(selectQuery, setSignalNoiseSeparationInputs)
    }, []);

    const toggleAudioPlay = (source) => {
        if (audio.src == source && currentlyPlayingAudio) {
            audio.pause();
            setCurrentlyPlayingAudio(false);
        }
        else {
            if (audio.src != source) {
                audio.src = source;
            }
            audio.play();
            setCurrentlyPlayingAudio(true)
        }
    }

    const getAudioButtonFromStatus = (file_name) => {
        if (audio.src.includes(file_name)) {
            return currentlyPlayingAudio ? <Pause /> : <PlayArrow />
        }
        return <PlayCircle />
    }

    const signalNoiseSeparationInputResultsColumns = [
        {
            field: 'actions',
            headerName: 'Actions',
            width: 70,
            renderCell: (params) => (
                <>
                    <Tooltip title="Play Audio">
                        <Button
                            onClick={() => { toggleAudioPlay(params.row.source) }}
                        >
                            {getAudioButtonFromStatus(params.row.name)}
                        </Button>
                    </Tooltip>
                </>
            ),
        },
        {
            field: 'id',
            headerName: 'ID',
            width: 340,
        },
        {
            field: 'name',
            headerName: 'Name',
            width: 440,
        },
        {
            field: 'type',
            headerName: 'Type',
            width: 340,
        },
        {
            field: 'bucket',
            headerName: 'Bucket',
            width: 340,
        },
        {
            field: 'bucket_folder',
            headerName: 'Bucket Folder',
            width: 140,
        },
        {
            field: 'created_date',
            headerName: 'Created Date',
            width: 160
        }
    ];

    let signalNoiseSeparationInputResultsDataRows = signalNoiseSeparationInputs?.filter(data => data != null).map((snsi) =>
    ({
        id: snsi.id,
        name: snsi.name,
        bucket: snsi.bucket,
        bucket_folder: snsi.bucket_folder,
        type: snsi.type,
        created_date: snsi.created_date,
        source: "https://storage.cloud.google.com/" + snsi.bucket + "/" + snsi.bucket_folder + "/" + snsi.name
    }))


    if (signalNoiseSeparationInputs === undefined) {
        return (<p>loading...</p>)
    }
    return (
        <DataGrid
            disableSelectionOnClick
            rows={signalNoiseSeparationInputResultsDataRows}
            columns={signalNoiseSeparationInputResultsColumns}
            pagination={true}
            checkboxSelection={selectionEnabled}
            onSelectionModelChange={(selectedSNSI) => {
                selectSignalNoiseSeparationInput(selectedSNSI);
            }}
            selectionModel={selectedSignalNoiseSeparationInput}
            />
    )
};

export { SignalNoiseSeparationInputTable };
